import map from 'lodash/map';
import toArray from '../helpers/toArray';

const MINIMAL_LOADING_DURATION = 150;

const SPINNER = '<i class="fas fa-spinner"></i>';

const FormStore = {
  /**
   * Create behaviour for storing the form on the server with AJAX
   * @param {Node} node
   * @return {void}
   */
  create(node) {
    this.node = node;
    this.errorsContainer = this.node.querySelector('.js-form-store-errors');

    $(node).on('click', '[type="submit"]', this.onSubmit.bind(this));
  },

  /**
   * Handle form submissions
   * @param {Object} e Event object
   * @return {void}
   */
  onSubmit(e) {
    // Do nothing if the form is invalid
    if (!this.checkValidity(this.node)) {
      return;
    }

    this.target = e.target;

    // Save the loading time to calculate duration of saving after the request
    this.startLoading = Date.now();

    // Set the button to a waiting state
    this.toggleSaveButtonState('waiting');

    // Save the form
    this.submitForm(this.node, e.currentTarget);

    e.preventDefault();
  },

  /**
   * Check if the form element is valid
   * @param {HTMLFormElement} form
   * @return {Boolean}
   */
  checkValidity(form) {
    return !form.checkValidity || form.checkValidity();
  },

  /**
   * Change the submit button state
   * @param {String} state waiting or default
   * @return {void}
   */
  toggleSaveButtonState(state) {
    const submitButtons = toArray(this.node.querySelectorAll('[type="submit"]'));

    submitButtons.forEach((btn) => {
      if (state === 'waiting') {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('data-save-text', btn.innerHTML);
        btn.innerHTML = `${SPINNER} ${btn.getAttribute('data-saving-text')}`;
        return;
      }

      if (state === 'default') {
        btn.innerHTML = btn.getAttribute('data-save-text');
      }

      btn.removeAttribute('disabled');
    });
  },

  /**
   * Save the form to the server
   * @param {HTMLFormElement} form
   * @param {HTMLElement} target
   * @return {Promise}
   */
  submitForm(form, target) {
    const formData = new FormData(form);

    if (typeof target.name !== 'undefined' && target.name !== '') {
      formData.append(target.name, typeof target.value !== 'undefined' ? target.value : target.name);
    }

    return window.axios({
      method: 'post',
      url: form.getAttribute('action'),
      data: formData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })
      .then(() => {
        this.handleSuccessResponse();
      })
      .catch((res) => {
        this.handleErrorResponse(res);

        if (
          typeof res.response !== 'undefined'
          && typeof res.response.data !== 'undefined'
          && typeof res.response.data.errors !== 'undefined'
        ) {
          this.outputErrors(res.response.data.errors);
        }
      });
  },

  /**
   * Handle a succesful response from the server
   * @return {void}
   */
  handleSuccessResponse() {
    const endLoading = Date.now();
    const timeDiff = endLoading - this.startLoading;

    if (this.errorsContainer) {
      this.errorsContainer.style.display = 'none';
    }

    if (this.target.value === 'save_and_back') {
      window.location.replace(this.target.getAttribute('data-back-url'));
    } else {
      window.toaster.show(window.LANG.saveSuccess, 4000);
    }

    if (timeDiff < MINIMAL_LOADING_DURATION) {
      const waitingLeft = MINIMAL_LOADING_DURATION - timeDiff;

      setTimeout(() => {
        this.restoreUI();
      }, waitingLeft);

      return;
    }

    this.restoreUI();
  },

  /**
   * Reset the buttons and UI back to their original state
   * @return {void}
   */
  restoreUI() {
    this.toggleSaveButtonState('default');
  },

  /**
   * Handle a error response from the server
   * @param {Object} res Response object
   * @return {void}
   */
  handleErrorResponse(/* res */) {
    window.toaster.show(window.LANG.saveError, 6000, 'danger');
  },

  /**
   * Output errors to the page
   * @param {Object} errors
   * @return {void}
   */
  outputErrors(errors) {
    if (this.errorsContainer) {
      const errorsElement = map(errors, (error) => (`<li>${error}</li>`)).join('');

      this.errorsContainer.innerHTML = `
        <strong class="mb-2 d-block">Foutmeldingen</strong>
        <ul class="mb-1">
            ${errorsElement}
        </ul>
      `;

      this.errorsContainer.style.display = 'block';
    }

    this.restoreUI();
  },
};

export default FormStore;
